module.exports = __webpack_public_path__ + "img/mb_product_bg.4ebea00.webp";